import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const getContact = async (endpoint, tableName, id) => {
  try {
    const url = `${baseUrl}/aws/contacts/${id}`
    const response = await axios.get(url)

    return response.data || null
  } catch (error) {
    if (axios.isAxiosError(error) && (error as any).response?.status === 404) {
      return null // ✅ Gracefully handle 404
    }

    console.error('Error fetching contact:', error)
    throw error
  }
}

export const useContact = (contactId: string | undefined, queryKey = ['contact', contactId]) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['contact', contactId],
    queryFn: () => getContact('/aws/contacts', 'contacts', contactId),
    enabled: !!contactId && contactId !== 'null' && contactId !== 'undefined',
    retry: false,
    select: data => data ?? null,
  })

  // Return in the same format as the original hook
  return {
    data: data, // Map data to `organization`
    isLoading,
    isError,
    error,
  }
}
